/* One year of one subject. A grid, not a row: this is the leaf, and a strip
   that scrolls would hide half of what the reader came for.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md. */

import { useParams } from "react-router-dom";
import { covers } from "../../lib/covers";
import { useI18n } from "../../lib/i18n";
import { usePortal } from "../../lib/portal";
import { useIndex, itemsIn } from "../../lib/hooks";
import { Billboard, Crumbs, Grid, Tile } from "./Tile";
import { NotFound } from "../NotFound";
import { TileFoot, tileSub } from "./entry";

export function YearPage() {
  const { strand = "", subject = "", year = "" } = useParams();
  const { t, ui, href } = useI18n();
  const { taxonomy } = usePortal();
  const { data: index } = useIndex();
  if (!taxonomy) return null;

  const s = taxonomy.strands[strand], sub = taxonomy.subjects[subject];
  const y = Number(year);
  if (!s || !sub || !Number.isFinite(y)) return <NotFound />;

  const items = index ? itemsIn(index, strand, subject, y) : [];
  if (index && !items.length) return <NotFound />;

  /* The branch every tile on this page is being seen in: it decides the palette
     of the column and, with the strand's span of years, the density. */
  const branch = { strand, years: s.years };

  return (
    <div className="catalog">
      <Crumbs parts={[
        { label: ui("nav.home"), to: href("/") },
        { label: t(s.short), to: href(`/s/${strand}`) },
        { label: t(sub.name), to: href(`/s/${strand}/${subject}`) },
        { label: `${y}. ${ui("year.suffix")}` },
      ]} />
      <Billboard art={covers.year(branch, subject, y)}
                 eyebrow={`${t(sub.name)} · ${t(s.short)}`}
                 title={`${y}. ${ui("year.suffix")}`} />
      <Grid>
        {items.map((e) => (
          <Tile key={e.id} to={href(`/m/${e.id}`)} art={covers.material(e, branch)}
                title={e.title} sub={tileSub(e)} foot={<TileFoot entry={e} />} />
        ))}
      </Grid>
    </div>
  );
}
